import { clearElement, htmlElement } from './utils.js';

export const ASTROLOGY_DISCLAIMER_TEXT = Object.freeze({
  en: 'Astrological interpretation for guidance only. Not financial or investment advice. Consult a SEBI-registered advisor for financial decisions.',
  hinglish: 'Yeh jyotishiya vyakhya sirf margdarshan ke liye hai. Yeh financial ya investment advice nahi hai. Financial faislon ke liye SEBI-registered advisor se salah lein.',
});

export function getDisclaimerLines(language = 'en') {
  if (language === 'both') {
    return [ASTROLOGY_DISCLAIMER_TEXT.en, ASTROLOGY_DISCLAIMER_TEXT.hinglish];
  }
  return [ASTROLOGY_DISCLAIMER_TEXT[language] || ASTROLOGY_DISCLAIMER_TEXT.en];
}

export function getDisclaimerText(language = 'en') {
  return getDisclaimerLines(language).join('\n');
}

export function createDisclaimerElement({
  language = 'en',
  className = 'aat-disclaimer',
  role = 'note',
} = {}) {
  const wrapper = htmlElement('div', { className, role });
  getDisclaimerLines(language).forEach((line) => {
    wrapper.append(htmlElement('p', { text: line }));
  });
  return wrapper;
}

/**
 * Reusable footer for HTML/PDF report pipelines. Add this to the report root
 * before handing the DOM to the existing Kundlistar report renderer.
 */
export function renderReportDisclaimerFooter(container, options = {}) {
  if (!(container instanceof Element)) {
    throw new TypeError('container must be a DOM Element.');
  }
  clearElement(container);
  const footer = htmlElement('footer', { className: 'aat-report-disclaimer-footer' });
  footer.append(createDisclaimerElement(options));
  container.append(footer);
  return footer;
}
